import React from 'react';
import SplideServices from '../Services/SplideServices';

const About = ({ showButton = true }) => {
  return (
    <>
    <div className="container-fluid overflow-hidden py-5 px-lg-0">
      <div className="container about py-5 px-lg-0">
        <div className="row g-5 mx-lg-0">
          <div className="col-lg-6 ps-lg-0 wow fadeInLeft" data-wow-delay="0.1s" style={{ minHeight: "400px" }}>  
            <div className="position-relative h-100">
              <img className="position-absolute img-fluid w-100 h-100" src="/img/WhatsApp Image 2025-09-07 at 9.21.53 PM.jpeg" alt="" style={{ objectFit: "cover" }}/>
            </div>
          </div>
          <div className="col-lg-6 about-text wow fadeInUp" data-wow-delay="0.3s">
            <h6 className="text-secondary text-uppercase mb-3">About Us</h6>
            <h1 className="mb-5">Industrial Tools & Consumables Solutions</h1>
            <p className="mb-5">
              R.S. Industrial Solutions, founded in 2021, is a well-established proprietorship firm engaged in the trading of high-quality industrial tools and consumables. Our extensive product range includes Lubrication Equipment, Pneumatic Tools, Hydraulic Equipment, Hand Tools, Cutting Tools, Power Tools, Abrasives, PPEs, Lifting Equipment, and complete Automobile Workshop solutions.
            </p>
            <div className="row g-4 mb-5">
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.5s">
                <i className="fa fa-globe fa-3x text-primary mb-3"></i>
                <h5>Quality Assurance</h5>
                <p className="m-0">Our team of industry professionals ensures that every product meets international quality standards through advanced testing technologies.</p>
              </div>
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.7s">
                <i className="fa fa-shipping-fast fa-3x text-primary mb-3"></i>
                <h5>On-Time Delivery</h5>
                <p className="m-0">We are committed to timely deliveries, offering customized solutions at competitive prices to meet the exact needs of our clients.</p>
              </div>
            </div>
            {showButton && <a href="/about" className="btn btn-primary py-3 px-5">Explore More</a>}
          </div>
        </div>
      </div>
    </div>
      </>
  );
}

export default About;
